var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback } from 'react';
import { api, apiResolve, useApiGet } from '@sierralabs/core-ui';
export function getPresignedUrl(folderPath, mimeType) {
    return apiResolve(api.get('files/presign', { folderPath, mimeType }));
}
export function useGetPresignedUrl(folderPath) {
    const _a = useApiGet('files/presign'), { data, get } = _a, result = __rest(_a, ["data", "get"]);
    const getPresignedUrl = useCallback((mimeType) => get({ folderPath, mimeType }), [folderPath, get]);
    return Object.assign(Object.assign({ presignedUrl: data }, result), { getPresignedUrl });
}
//# sourceMappingURL=useGetPresignedUrl.js.map